import React, { ReactNode } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";

type ModalPoliticaProps = {
  titulo: string,
  textoHTML: string,
  children?: ReactNode,
  visivel: boolean,
  hide: any,
};

class ModalPolitica extends React.Component<ModalPoliticaProps, {}> {

  render(): any {
    return (
      <Dialog open={this.props.visivel}>
        <DialogContent>
          <div className="modal" id="politica-modal">
            <p className="title">{this.props.titulo}</p>
            <div dangerouslySetInnerHTML={{ __html: this.props.textoHTML }} />
            <div className="menu">
              <button onClick={ this.props.hide }>Fechar</button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

export default ModalPolitica;